import { Box, Typography, useTheme } from '@material-ui/core'
import { CustomTooltip } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { useTranslation } from 'react-i18next'
import { BulkSettings, Competitor, PriceStategyTarget, PricingStrategy } from 'shared'
import { PricingStrategiesEditor } from './PricingStrategiesEditor'

export interface PricingStrategiesPresenterProps {
  pricingStrategies: Array<PricingStrategy>
  competitors: Array<Competitor>
  onDelete: (id: string) => void
  onCreate: (target: PriceStategyTarget) => void
  onChange: (newValue: PricingStrategy) => void
  onClone: (newValue: PricingStrategy) => void
  onConvertTo?: (newValue: PricingStrategy) => void
  competitionDisabled: boolean
  bulkSettings: Array<BulkSettings>
  target: PriceStategyTarget
}

export const PricingStrategiesPresenter = ({
  pricingStrategies,
  competitors,
  onDelete,
  onCreate,
  onChange,
  onClone,
  onConvertTo,
  competitionDisabled,
  bulkSettings,
  target,
}: PricingStrategiesPresenterProps): JSX.Element => {
  const { t } = useTranslation()
  const { palette } = useTheme()
  const { activeGame } = useUser()

  const isBuy = target === PriceStategyTarget.buyPrice

  return (
    <>
      <h2 className="mb-4">
        {isBuy ? t('strategy.yourBuyStrategies') : t('strategy.yourStrategies')}
      </h2>
      <p>{t('strategy.descriptionText')}</p>
      <p>{t('strategy.descriptionTextCompetition')}</p>

      <CustomTooltip
        title={
          <Box padding={1}>
            <Typography variant={'body2'}>
              <b>{t('card.set')}:</b> {t('strategy.conditions.set')}
            </Typography>
            <Typography variant={'body2'}>
              <b>{t('card.condition')}:</b> {t('strategy.conditions.condition')}
            </Typography>
            <Typography variant={'body2'}>
              <b>{t('card.extra')}:</b> {t('strategy.conditions.extra')}
            </Typography>
            <Typography variant={'body2'}>
              <b>{t('card.quantity')}:</b>{' '}
              {t('strategy.conditions.quantity', { playsetCount: activeGame.playsetCount })}
            </Typography>
            <Typography variant={'body2'}>
              <b>{t('card.language')}:</b> {t('strategy.conditions.language')}
            </Typography>
          </Box>
        }
      >
        <Typography
          variant="body2"
          gutterBottom
          style={{ color: palette.primary.main, cursor: 'help', width: 'fit-content' }}
        >
          {t('strategy.equalOrBetter')}
        </Typography>
      </CustomTooltip>
      {competitionDisabled && (
        <Typography gutterBottom variant="body2">
          <b>{t('competitionDisabled')}</b>
        </Typography>
      )}
      <Box padding={2}>
        <PricingStrategiesEditor
          pricingStrategies={pricingStrategies}
          competitors={competitors}
          onDelete={onDelete}
          onCreate={onCreate}
          onChange={onChange}
          onClone={onClone}
          onConvertTo={onConvertTo}
          rowCount={2}
          competitionDisabled={competitionDisabled}
          bulkSettings={bulkSettings}
          target={target}
        />
      </Box>
    </>
  )
}
